<template>
    <div class="articleListDetail detailPage">
        <div class="head">文章详情</div>
        <div class="main">
            <DetailPage  :detailData="list" :fields="fields">
                <template v-slot:title_color="{ item }">
                    <el-color-picker v-model="item.content" class="disable"></el-color-picker>
                </template>
                <template v-slot:article_category_id="{ item }">
                    <div v-for="(i,index) in classification" :key="index">
                       <div v-if="i.value === item.content">{{i.label}}</div>
                    </div>
                </template>
                <template v-slot:is_enable="{ item }" >
                   <CheckBox :value="!!item.content"/>
                </template>
                <template v-slot:content="{ item }" >
                   <div v-html="item.content"></div>
                </template>
                <template v-slot:add_time="{ item }" >
                   {{ item.content*1000 | dateFormat('YYYY-MM-DD') }}
                </template>
                <template v-slot:upd_time="{ item }" >
                   {{ item.content*1000 | dateFormat('YYYY-MM-DD') }}
                </template>
            </DetailPage>
        </div>
        
    </div>
</template>

<script>
import { ArticleService } from '../../service/article.service'
import  DetailPage from '@/components/detailPage/detailPage.component'
const fields = [{ key: 'id', name: 'id'},{ key: 'title', name: '标题'},{ key: 'title_color', name: '标题颜色', type: 'custom'},{ key: 'article_category_id', name: '分类', type: 'custom'},{ key: 'jump_url', name: '跳转地址'},{ key: 'is_enable', name: '是否显示', type: 'custom'},{ key: 'content', name: '内容', type: 'custom'},{ key: 'access_count', name: '热度' },{ key: 'seo_title', name: 'seo标题'},{ key: 'seo_keywords', name: 'seo关键字' },{ key: 'seo_desc', name: 'seo描述'},{ key: 'add_time',name: '添加时间', type: 'custom'},{ key: 'upd_time',name: '上传时间',type: 'custom'}]
export default {
    name: 'articleListDetail',
    components:{ DetailPage },
    data() {
        return {
            list: [],
            fields,
            classification:JSON.parse(localStorage.getItem('classification')),
            routeQuery: this.$route.query
        }
    },
    methods: {
    },
    async activated() {
        const data = await ArticleService.getArticleDetail(this.$route.query);
        this.list = data
    }
}
</script>
